/*
 * @Author: cc
 * @Date: 2020-03-09 11:11:42
 * @LastEditTime: 2020-04-26 14:51:21
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\inlineEdit\trsInlineCreate.js
 * @Description: 为图片增加“添加到个人素材”功能
 */
'use strict';


angular.module('util.trsAddToCreate', []).directive('trsAddToCreate', [
    '$window',
    '$state',
    '$stateParams',
    'trsHttpService',
    '$timeout',
    'modalDialog',
    'mrApiService',
    function ($window, $state, $stateParams, trsHttpService, $timeout, modalDialog, mrApiService) {
        // Runs during compile
        return {
            scope: {
                author: '@',
                data: '=',
                imgTitle: '=',
                docId: '@', // 兼容快速预览右侧详情时，导航栏上无guid的情况
            }, // {} = isolate, true = child, false/undefined = no change
            restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
            link: function ($scope, $element, iAttrs, controller) {
                var paddingLeft = parseInt(iAttrs['trsCreatePaddingLeft'] || 0, 10);
                var paddingTop = parseInt(iAttrs['trsCreatePaddingTop'] || 0, 10);
                var identity = parseInt(Math.random() * 10000);
                var imgIdentity = iAttrs['imgIdentity'];
                var $imgElement;

                /**
                 * [hideShare 隐藏添加到个人素材的按钮]
                 * @return  {[type]}  [return description]
                 */
                function hideShare() {
                    $('#imgSinaShare_' + identity).hide();
                }

                /**
                 * [documentMousedownHandler 鼠标按下事件]
                 * @param   {[type]}  event  [event description]
                 * @return  {[type]}         [return description]
                 */
                function documentMousedownHandler(event) {
                    if (event.target.id === 'imgSinaShare_' + identity) {
                        return;
                    }
                    hideShare();
                }

                $(document).bind('mousedown', documentMousedownHandler);
                $(document).bind('mousewheel', documentMousedownHandler);
                $scope.$on('$destroy', function () {
                    $(document).unbind('mousedown', documentMousedownHandler);
                });

                $timeout(function () {
                    // 如果指定了滚动的元素，则在该元素下插入节点
                    if (iAttrs['scrollDivClass']) {
                        $element
                            .parents('.' + iAttrs['scrollDivClass'])
                            .append('<img title="" class="trsInlineCreate" id="imgSinaShare_' + identity + '" src="./images/createLine.png" />');
                        var scrollDivOffsetLeft = $('.' + iAttrs['scrollDivClass']).offset().left;
                        var scrollDivOffsetTop = $('.' + iAttrs['scrollDivClass']).offset().top;
                    } else {
                        $(document.body).append(
                            '<img title="" class="trsInlineCreate" id="imgSinaShare_' + identity + '" src="./images/createLine.png" />'
                        );
                    }
                    $scope.$on('$destroy', function () {
                        $('#imgSinaShare_' + identity).remove();
                    });

                    var $sinaMiniBlogShare = function (eleShare) {
                        var eleTitle = $window.document.getElementsByTagName('title')[0];

                        var funGetSelectTxt = function () {
                            var txt = '';
                            if ($window.document.selection) {
                                txt = $window.document.selection.createRange().text; // IE
                            } else {
                                txt = $window.document.getSelection();
                            }
                            return txt;
                        };

                        var showShare = function (position) {
                            eleShare.style.display = 'inline';
                            eleShare.style.left = position.left + 'px';
                            eleShare.style.top = position.top + 'px';
                        };

                        $element.bind('mouseup', function (event) {
                            // 延迟是为了确保触发其他地方点击的时候原先的选中效果已经消失
                            $timeout(function () {
                                var target = event.target;
                                $imgElement = undefined;
                                if (target == eleShare) {
                                    return;
                                }

                                var txt = funGetSelectTxt();
                                if (txt != '' && txt.toString().replace(/\n/g, '') != '') {
                                    var position = {};
                                    var e = event;
                                    var sh =
                                        $window.pageYOffset || $window.document.documentElement.scrollTop || $window.document.body.scrollTop || 0;
                                    if (angular.isDefined(iAttrs['scrollDivClass'])) {
                                        var offsetTop = scrollDivOffsetTop - $element.parents('.' + iAttrs['scrollDivClass']).scrollTop();
                                        position.left =
                                            e.clientX - scrollDivOffsetLeft - 40 < 0
                                                ? e.clientX - scrollDivOffsetLeft + 20
                                                : e.clientX - scrollDivOffsetLeft - 40;
                                        position.top =
                                            e.clientY - offsetTop - 40 < 0 ? e.clientY - offsetTop + sh + 20 : e.clientY - offsetTop + sh - 40;
                                    } else {
                                        position.left = e.clientX - 40 < 0 ? e.clientX + 20 : e.clientX - 40;
                                        position.top = e.clientY - 40 < 0 ? e.clientY + sh + 20 : e.clientY + sh - 40;
                                    }
                                    showShare(position);
                                } else {
                                    hideShare();
                                }
                            }, 100);
                        });

                        var currImg;
                        // $element.find('img').bind('mouseenter', function(event) {
                        $element.delegate('img', 'mouseenter', function (event) {
                            var target = event.target;
                            if (event.target.className === 'videoMark' || event.target.getAttribute('videoid') || event.target.className === 'li-Img') {
                                return;
                            } // 视频图片上的盖子和代表视频的图片均不加入创作轴
                            $imgElement = $(event.target);
                            if (target === eleShare) {
                                return;
                            }

                            var $target = $(target);
                            if (imgIdentity) {
                                $target = $target.closest(imgIdentity);
                            }

                            var tPosition = $target.offset();
                            var position = {};
                            if (angular.isDefined(iAttrs['scrollDivClass'])) {
                                var offsetTop = scrollDivOffsetTop - $element.parents('.' + iAttrs['scrollDivClass']).scrollTop();
                                position.left = tPosition.left + paddingLeft - scrollDivOffsetLeft;
                                position.top = tPosition.top + paddingTop - offsetTop;
                            } else {
                                position.left = tPosition.left + paddingLeft;
                                position.top = tPosition.top + paddingTop;
                            }
                            currImg = $target[0];
                            showShare(position);
                        });

                        $element.bind('mousemove', function (event) {
                            if (!currImg) {
                                return;
                            }

                            var bounding = currImg.getBoundingClientRect();
                            if (
                                event.clientX < bounding.left ||
                                event.clientX > bounding.right ||
                                event.clientY < bounding.top ||
                                event.clientY > bounding.bottom
                            ) {
                                currImg = null;
                                hideShare();
                            }
                        });
                        if (eleShare){
                            var events = $._data(eleShare, 'events'); // 防止同一个页面两次调用该指令时，添加创作轴按钮重复绑定点击事件的问题
                            if (!events || !events['click']) {
                                buttonBindClick();
                            }
                        }
                        
                        /**
                         * [buttonBindClick description] 按钮点击
                         * @return  {[type]}  [return description]
                         */
                        function buttonBindClick() {
                            $(eleShare).bind('click', function (event) {
                                hideShare();
                                var txt = funGetSelectTxt(),
                                    title = eleTitle && eleTitle.innerHTML ? eleTitle.innerHTML : '未命名页面';
                                var content, imgname, imgauthor;
                                var channelName,
                                    indexName,
                                    id =
                                        $stateParams.guid ||
                                        $stateParams.metadata ||
                                        $stateParams.metadataid ||
                                        $stateParams.iwometadataid ||
                                        $stateParams.wzmetadataid ||
                                        $stateParams.appmetadataid ||
                                        $stateParams.bzmetadata ||
                                        $stateParams.wxmetadataid;
                                var currImgCopy = angular.copy(currImg);
                                var imgTitle =
                                    angular.isDefined($scope.imgTitle) && $scope.imgTitle !== null ? $scope.imgTitle.replace(/\n+/g, ' ') : '';
                                if (currImg) {
                                    var imgSrc = angular.isDefined(currImgCopy.src) ? currImgCopy.src : currImgCopy.getAttribute('trs-src');
                                    var imgnameSrcArray = imgSrc.split('/');
                                    if (imgnameSrcArray[imgnameSrcArray.length - 1].indexOf('_600.') > 0) {
                                        imgnameSrcArray[imgnameSrcArray.length - 1] = imgnameSrcArray[imgnameSrcArray.length - 1].replace(
                                            /_600./g,
                                            '.'
                                        );
                                        currImgCopy.src = imgnameSrcArray.join('/');
                                    }
                                    // 融合稿件详情页传SRCPICURL字段，SRCPICURL字段从新增的属性data-create-url中获取
                                    imgname = currImgCopy.getAttribute('data-create-url') || currImgCopy.src || currImgCopy.getAttribute('trs-src');
                                    content = '';
                                    imgauthor = currImgCopy.getAttribute('IMGAUTHOR') || '';
                                    channelName = currImgCopy.getAttribute('trs-channelName');
                                    indexName = currImgCopy.getAttribute('trs-indexName');
                                } else if (txt) {
                                    imgname = '';
                                    content = txt.toString();
                                    imgauthor = '';
                                }
                                if (!content && !imgname) {
                                    return;
                                }
                                if ($imgElement && ($imgElement.attr('videoid') || $imgElement.attr('audioid'))) {
                                    addToCreationFromWCM(imgname, imgauthor, content, imgTitle, id);
                                } else if (
                                    (angular.isDefined(id) && angular.isUndefined($stateParams.isugc)) ||
                                    angular.isDefined($stateParams.metadataid)
                                ) {
                                    // WCM
                                    if ($state.params.mlftype == '1' || $state.params.mlftype == '9') {
                                        addToCreationFromBD(imgname, content, imgTitle, id, indexName);
                                    } else if (angular.isDefined(id) && angular.isDefined($stateParams.guid)) {
                                        // 新华社稿件有metadataid但是走大数据方法
                                        addToCreationFromBD(imgname, content, imgTitle, id, channelName, indexName, true);
                                    } else {
                                        // 稿件收藏虽然在采编中心，但是仍然要调资源中心的加入创作轴方法
                                        addToCreationFromWCM(imgname, imgauthor, content, imgTitle, id);
                                    }
                                } else if (angular.isDefined(id) && angular.isDefined($stateParams.isugc)) {
                                    addToCreationFromBD(imgname, content, imgTitle, id, channelName, indexName, true);
                                } else if ($state.current.name === 'resourcexhsgbigdatadetail') {
                                    // 新华社稿
                                    if (imgname) {
                                        addToPersonelMeizi(imgTitle, imgname);
                                    } else {
                                        addToCreationFromXinhua($stateParams.docid, $state.params.channel, content);
                                    }
                                } else {
                                    // 大数据
                                    if (angular.isDefined($scope.docId)) {
                                        // 兼容快速预览右侧详情时，导航栏上无guid的情况
                                        $stateParams.docId = $scope.docId;
                                    }
                                    addToCreationFromBD(imgname, content, imgTitle, id, channelName, indexName);
                                }
                            });
                        }
                    };
                    $sinaMiniBlogShare($window.document.getElementById('imgSinaShare_' + identity));
                }, 500);

                /**
                 * [addToCreationFromWCM description]
                 * @param   {[type]}  imgname     [imgname description] 从WCM加入到创作轴
                 * @param   {[type]}  imgauthor   [imgauthor description] 图片路径
                 * @param   {[type]}  content     [content description] 正文
                 * @param   {[type]}  imgTitle    [imgTitle description]
                 * @param   {[type]}  metadataid  [metadataid description]
                 * @return  {[type]}              [return description]
                 */
                function addToCreationFromWCM(imgname, imgauthor, content, imgTitle, metadataid) {
                    var isVideo =
                        angular.isDefined($imgElement) &&
                        (angular.isDefined($imgElement.attr('audioid')) || angular.isDefined($imgElement.attr('videoid')));
                    if (imgname && !isVideo) {
                        addToPersonelMeizi(imgTitle, imgname);
                        return;
                    }
                    var params;
                    // 如果该img元素为音视频，则调用音视频添加个人素材的方法
                    if (isVideo) {
                        params = {
                            serviceid: 'mlf_releaseSource',
                            methodname: angular.isDefined($imgElement.attr('videoid')) ? 'addPersonalMaterialOfVideo' : 'addPersonalMaterialOfAudio',
                            PersonalMaterialId: '0',
                            fileDesc: $imgElement.attr('filename') || 'ugc视频',
                            fileName: $imgElement.attr('filename') || 'ugc视频',
                            fileSize: $imgElement.attr('filesize') || 100,
                            videoId: angular.isDefined($imgElement.attr('videoid')) ? $imgElement.attr('videoid') : $imgElement.attr('audioid'),
                        };
                        // 如果是ugc稿件，选择文字添加到个人素材库，使用这个参数
                    } else if ($state.params.isugc === 'true') {
                        params = {
                            serviceid: 'mlf_ugc',
                            methodname: 'creation',
                            id: metadataid || $state.params.metadata,
                            content: content,
                            Title: imgTitle,
                        };
                    } else {
                        params = {
                            serviceid: 'mlf_releasesource',
                            methodname: 'addPersonalMaterialOfTxt',
                            PersonalMaterialId: '0',
                            metadataid: metadataid || $stateParams.metadata,
                            imgname: imgname,
                            imgauthor: imgauthor,
                            content: content,
                            Title: imgTitle,
                        };
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        modalDialog.alertType('添加成功', '', 'success', false);
                        $window.document.getSelection().collapse($window.document, 1);
                        // console.log("加入WCM创作轴成功");
                    });
                }

                /**
                 * [addToCreationFromBD description] 从大数据加入到创作轴
                 * @param   {[type]}  imgname      [imgname description] 图片路径
                 * @param   {[type]}  content      [content description] 正文
                 * @param   {[type]}  imgTitle     [imgTitle description]
                 * @param   {[type]}  id           [id description]
                 * @param   {[type]}  channelName  [channelName description]
                 * @param   {[type]}  indexName    [indexName description]
                 * @param   {[type]}  isugc        [isugc description]
                 * @return  {[type]}               [return description]
                 */
                function addToCreationFromBD(imgname, content, imgTitle, id, channelName, indexName, isugc) {
                    if (imgname) {
                        addToPersonelMeizi(imgTitle, imgname);
                        return;
                    }
                    var params;
                    if (angular.isDefined(isugc) && isugc === true) {
                        params = {
                            serviceid: 'mlf_bigdataexchange',
                            methodname: 'addPersonalMaterial',
                            PersonalMaterialId: '0',
                            guid: id,
                            channelName: 'ugc',
                            indexName: '',
                            imgname: imgname,
                            content: content,
                            Title: imgTitle,
                        };
                    } else {
                        params = {
                            serviceid: 'mlf_bigdataexchange',
                            methodname: 'addPersonalMaterial',
                            PersonalMaterialId: '0',
                            guid: id,
                            channelName: channelName || $stateParams.channel || 'iwo',
                            indexName: indexName || $stateParams.indexname || '',
                            imgname: imgname,
                            content: content,
                            Title: imgTitle,
                        };
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        modalDialog.alertType('添加成功', '', 'success', false);
                        $window.document.getSelection().collapse($window.document, 1);
                        // console.log("加入BD创作轴成功");
                    });
                }

                /**
                 * [addToPersonelMeizi description] 添加到媒资库个人素材
                 *
                 * @param   {[type]}  imgTitle  [imgTitle description]
                 * @param   {[type]}  imgname   [imgname description]
                 *
                 * @return  {[type]}            [return description]
                 */
                function addToPersonelMeizi(imgTitle, imgname) {
                    if (!imgTitle) {
                        var imgPathArr = imgname.split('?')[0].split('/');
                        imgTitle = imgPathArr[imgPathArr.length - 1];
                    }
                    mrApiService
                        .addToPersonel({
                            mrType: 'personal',
                            mainResourceType: '0',
                            fileName: imgTitle,
                            tempUrl: imgname,
                        })
                        .then(function (data) {
                            if (data.code === '200') {
                                modalDialog.alertType('添加成功', '', 'success', false);
                                $window.document.getSelection().collapse($window.document, 1);
                            } else {
                                modalDialog.alertType('', data.msg, 'error', false);
                            }
                            // console.log("加入WCM创作轴成功");
                        });
                }

                /**
                 * [addToCreationFromXinhua description]新华社稿文字添加到个人素材
                 *
                 * @param   {[type]}  id           [id description]
                 * @param   {[type]}  channelName  [channelName description]
                 * @param   {[type]}  content      [content description]
                 *
                 * @return  {[type]}               [return description]
                 */
                function addToCreationFromXinhua(id, channelName, content) {
                    var params = {
                        serviceid: 'mlf_xhsgoper',
                        methodname: 'creation',
                        XHSGId: id,
                        channelName: channelName,
                        content: content
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        modalDialog.alertType('添加成功', '', 'success', false);
                        $window.document.getSelection().collapse($window.document, 1);
                    // console.log("加入BD创作轴成功");
                    });
                }
            },
        };
    },
]);
